import { useLocation } from 'js/lib/useRouter';

import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';
import { isAnnualByVariantId } from 'bundles/coursera-plus/constants/CourseraPlusProductVariant';

type ProductVariantUrlActionProps = {
  variant?: string;
  action?: string;
  selectedVariant?: string;
  [key: string]: string | undefined;
};

export const useProductVariantUrlAction = (): ProductVariantUrlActionProps => {
  const { courseraPlusAnnualWithFreeTrialEpicVariant, courseraPlusAnnualWithFreeTrialProduct } =
    useLandingPageExtended();
  const { query } = useLocation();
  const { variant, action, selectedVariant, ...queryRest } = query || {};

  let finalProductVariant = variant;
  if (
    isAnnualByVariantId(variant) &&
    ['1', '2', '3'].includes(courseraPlusAnnualWithFreeTrialEpicVariant) &&
    courseraPlusAnnualWithFreeTrialProduct?.productItemId
  ) {
    finalProductVariant = courseraPlusAnnualWithFreeTrialProduct.productItemId;
  }

  return { action, variant: finalProductVariant, selectedVariant, ...queryRest };
};
